import { useEffect, useMemo, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";

const inp = "bg-zinc-950 border border-zinc-700 rounded px-1 py-1 text-xs w-14 text-center";

// Saisie rapide du stock dojo en grille variante × taille (casques, gants, tibias…) — le produit passe « en stock » dès qu'une case > 0.
export function ProtectionStockGrid({ products, onSaved }) {
  const list = useMemo(() => (products || []).filter((p) => p.category === "obligatoire" && p.status !== "discontinue"), [products]);
  const [pid, setPid] = useState("");
  const [grid, setGrid] = useState({});
  const p = list.find((x) => x.id === pid);
  useEffect(() => {
    if (!p) return;
    const g = {};
    Object.entries(p.stock || {}).forEach(([k, v]) => { g[k] = v; });
    setGrid(g);
  }, [p]);
  const colors = p?.colors?.length ? p.colors : ["-"];
  const sizes = p?.sizes?.length ? p.sizes : ["-"];
  const key = (c, s) => `${c}|${s}`;
  const save = async () => {
    const rows = [];
    colors.forEach((c) => sizes.forEach((s) => rows.push({ color: c === "-" ? "" : c, size: s === "-" ? "" : s, on_hand: Number(grid[key(c, s)] || 0) })));
    try {
      const r = await api.post("/equipment-catalog/inventory/bulk", { product_id: pid, rows });
      toast.success(`Stock enregistré (${r.data.changed} case(s)) · ${r.data.status === "en_stock" ? "produit EN STOCK au dojo" : "aucun stock"}`);
      onSaved?.();
    } catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); }
  };
  const total = Object.values(grid).reduce((a, b) => a + Number(b || 0), 0);
  return (
    <div className="rounded-xl border border-amber-500/30 bg-amber-500/[0.04] p-4 space-y-3" data-testid="protection-stock-grid">
      <div className="flex flex-wrap items-center gap-3">
        <h3 className="font-semibold text-sm">🥊 Stock dojo — casques, gants, tibias (grille variante × taille)</h3>
        <select value={pid} onChange={(e) => setPid(e.target.value)} className="bg-zinc-950 border border-zinc-700 rounded px-2 py-1 text-xs" data-testid="psg-product">
          <option value="">— Choisir un article obligatoire —</option>
          {list.map((x) => <option key={x.id} value={x.id}>{x.name} ({x.status === "en_stock" ? "en stock" : "sur commande"})</option>)}
        </select>
        {p && <span className="text-xs text-zinc-400">Total saisi : <b className="text-zinc-100" data-testid="psg-total">{total}</b></span>}
      </div>
      {p && (
        <>
          <table className="text-xs" data-testid="psg-table">
            <thead><tr className="text-zinc-500"><th className="text-left pr-3">{p.variant_label || "Couleur"} \ Taille</th>{sizes.map((s) => <th key={s} className="px-1">{s}</th>)}</tr></thead>
            <tbody>
              {colors.map((c) => (
                <tr key={c} className="border-t border-zinc-800">
                  <td className="py-1 pr-3 text-zinc-200">{c}</td>
                  {sizes.map((s) => <td key={s} className="px-1"><input type="number" min="0" value={grid[key(c, s)] ?? ""} onChange={(e) => setGrid({ ...grid, [key(c, s)]: e.target.value })} placeholder="0" className={inp} data-testid={`psg-cell-${c}-${s}`.replace(/\s/g, "_")} /></td>)}
                </tr>
              ))}
            </tbody>
          </table>
          <button onClick={save} className="px-3 py-1.5 rounded bg-amber-500 text-zinc-950 text-xs font-semibold" data-testid="psg-save">Enregistrer le stock</button>
          <p className="text-[11px] text-zinc-500">Les membres verront « En stock au dojo (tailles…) » et le bouton « Acheter sur place » dans leur Espace Membres.</p>
        </>
      )}
    </div>
  );
}
